/* eslint react/no-find-dom-node: 0 */
import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { TimelineMax, Power2 } from 'gsap'
export { default as TransitionGroup } from 'react-addons-transition-group'

class TransitionBox extends Component {
  static defaultProps = {
    duration: 0.2,
    className: ''
  }

  render () {
    return (
      <div
        style={{ overflow: 'hidden' }}
        className={this.props.className}
      >
        {this.props.children}
      </div>
    )
  }
}

export class SlideBox extends TransitionBox {
  componentWillEnter (callback) {
    const el = findDOMNode(this)

    new TimelineMax({ onComplete: callback, delay: this.props.duration })
      .set(el, { opacity: 0 })
      .from(el, {
        duration: this.props.duration,
        height: 0,
        ease: Power2.easeInOut
      }).to(el, {
        duration: this.props.duration,
        opacity: 1,
        ease: Power2.easeOut
      }).set(el, { height: 'auto' })
  }

  componentWillLeave (callback) {
    const el = findDOMNode(this)
    new TimelineMax({ onComplete: callback })
      .to(el, {
        duration: this.props.duration,
        opacity: 0,
        ease: Power2.easeIn
      }).to(el, {
        duration: this.props.duration,
        height: 0,
        ease: Power2.easeInOut
      }).set(el, { height: 'auto' })
  }
}

export class FadeBox extends TransitionBox {
  componentWillEnter (callback) {
    const el = findDOMNode(this)

    new TimelineMax({ onComplete: callback, delay: this.props.duration })
      .set(el, { opacity: 0 })
      .to(el, {
        duration: this.props.duration,
        opacity: 1,
        ease: Power2.easeOut
      })
  }

  componentWillLeave (callback) {
    const el = findDOMNode(this)
    new TimelineMax({ onComplete: callback })
      .to(el, {
        duration: this.props.duration,
        opacity: 0,
        ease: Power2.easeIn
      })
  }
}
